import React from "react";
import { graphql } from "gatsby";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowIcon from "../modules/ArrowIcon";

import SlideWithImageCard from "../modules/SlideWithImageCard";

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowIcon />
    </div>
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowIcon />
    </div>
  );
}

export default function CarouselWithImageSlider({ data }) {
  const { carouselContent } = data;

  const trimmedCarouselContent = carouselContent.filter(
    (page) => page.internal
  );

  const getComponentFromBlockType = (blockType) => {
    const components = {
      SlideWithImageCard,
    };

    const componentToRender = components[blockType.split("DatoCms")[1]];
    return componentToRender;
  };

  const renderCarouselContent = (pageContent, customClass) => {
    return pageContent.map((item, index) => {
      const key = index;
      const blockType = item.internal.type;
      const Component = getComponentFromBlockType(blockType);
      let settings = { key, customClass, data: item, blockType };
      if (!Component) {
        return <></>;
      }

      return <Component {...settings} />;
    });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    dotsClass: "slick-dots custom-indicator",
  };
  return (
    <Slider
      {...settings}
      customPaging={(i) => {
        return <div className="w-12 h-2" />;
      }}
    >
      {renderCarouselContent(trimmedCarouselContent, "")}
    </Slider>
  );
}

export const carouselQuery = graphql`
  fragment CarouselWithImageCardSlider on DatoCmsCarouselWithImageCardSlider {
    internal {
      type
    }
    carouselContent {
      ... on DatoCmsSlideWithImageCard {
        internal {
          type
        }
        backgroundImage {
          alt
          gatsbyImageData
        }
        title
      }
    }
  }
`;
